import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Финансовые предложения',
} satisfies TMessages
